<!-- A caixa INTEIRA é o campo: clicar em qualquer ponto foca o texto. -->
<div class="input-shell" (click)="focus()">
    <ng-content select="[raChatComposerTop]" />

    <textarea
        #textarea
        rows="1"
        [disabled]="disabled()"
        [placeholder]="placeholder()"
        [attr.aria-label]="placeholder() || null"
        (input)="onInput($event)"
        (keydown)="onKeydown($event)"></textarea>

    <div class="input-shell__bar">
        <span class="input-shell__start">
            <ng-content select="[raChatComposerStart]" />
        </span>

        <span class="input-shell__actions">
            @if (hint()) {
                <span class="input-shell__hint">{{ hint() }}</span>
            }
            @if (stoppable()) {
                <button
                    class="send-button stop"
                    type="button"
                    [disabled]="stopping()"
                    [attr.aria-label]="stopLabel() || null"
                    [attr.title]="stopLabel() || null"
                    (click)="$event.stopPropagation(); stop.emit()">
                    <span class="send-button__stop" aria-hidden="true"></span>
                </button>
            } @else {
                <button
                    class="send-button"
                    type="button"
                    [disabled]="disabled() || !canSend() || (!value().trim() && !allowEmpty())"
                    [attr.aria-label]="sendLabel() || null"
                    (click)="$event.stopPropagation(); submit()">
                    <svg class="send-button__icon" viewBox="0 0 24 24" aria-hidden="true">
                        <path d="M12 19V5" />
                        <path d="m5.5 11.5 6.5-6.5 6.5 6.5" />
                    </svg>
                </button>
            }
        </span>
    </div>
</div>
